import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=f7c10338&"
import script from "./ChangeDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports